import { render } from "./InventoryImportModal.vue?vue&type=template&id=5bf6c318"
import script from "./InventoryImportModal.vue?vue&type=script&lang=js"
export * from "./InventoryImportModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__